import script from "./AvailablePages.vue?vue&type=script&setup=true&lang=js"
export * from "./AvailablePages.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__